// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useQuery, { type QueryArgs } from '../../useQuery';
import { SocialAuthConfQueryDocument, type SocialAuthConfQuery, type SocialAuthConfQueryVariables } from './SocialAuthConfQuery';

export async function getSocialAuthConfQueryClient(variables: SocialAuthConfQueryVariables) {
  return fetchGraphqlClient<SocialAuthConfQuery, SocialAuthConfQueryVariables>(SocialAuthConfQueryDocument, "SocialAuthConfQuery", { variables });
}
export const useSocialAuthConfQuery = (...args: QueryArgs<SocialAuthConfQueryVariables>) => useQuery<SocialAuthConfQuery, SocialAuthConfQueryVariables>(getSocialAuthConfQueryClient, ...args);